// Content for Shashank Dixit's portfolio.
// {{double braces}} render as a highlighter mark, **bold** and *italic* also
// work — see <Marked /> in primitives.jsx

export const profileData = {
  name: "Shashank Dixit",
  title: "Builder-operator · Ex-EF EIR · Ex-Emergent",
  tagline: "Ex-Product Growth at Emergent ($1.5B). I'm building a platform where you run your entire marketing just by talking in English.",
  // Subhead under the tagline, from the resignation post
  resignation:
    "Just resigned at my peak from Emergent, where I led analytics for creator marketing. Not stepping off the AI wave. {{Leaving to build my own surfboard.}}",
  bio: "Started as a freelancer, then founded MagnumKare, working with hospitals on websites and social media despite having zero medical background not even a nurse in my entire bloodline. That exposure pulled me deeper into healthcare, where I began building real systems, not just services. I joined Entrepreneur First and built HealthNivaran, AI agents that interview patients beforehand and create a clean one-page clinical summary. Then I joined Emergent, an AI platform that turns a prompt into a deployed app, valued at $1.5 billion. In 8 months I went from product intern to leading analytics for creator marketing, then resigned at my peak to build again.",
  email: "shashankdixit099@gmail.com",
  location: "Bengaluru, Karnataka, India",
  availability: "Now building",
  followers: "7,057",
  connections: "500+",
  social: {
    linkedin: "https://www.linkedin.com/in/shashankdixitt/",
    twitter: "https://x.com/ShashankDixit_x",
    github: "https://github.com/Shashankdixitgit"
  }
};

/* Pills under the hero heading */
export const highlights = [
  "Ex-EF Entrepreneur in Residence",
  "Founded HealthNivaran at EF"
];

/* The card under the hero CTAs */
export const howIWork = {
  title: "The rule",
  body:
    "Pure data signals. No gut calls. We stopped asking {{\"Does this creator feel right?\"}} and started asking {{\"What does the data say works in this market?\"}}"
};

export const skills = [
  { name: "Attribution modelling", category: "Product Analytics" },
  { name: "Funnel analysis", category: "Product Analytics" },
  { name: "Cohort analysis", category: "Product Analytics" },
  { name: "A/B testing", category: "Product Analytics" },
  { name: "Event instrumentation", category: "Product Analytics" },
  { name: "Retention analysis", category: "Product Analytics" },
  { name: "SQL reporting", category: "Product Analytics" },
  { name: "Dashboarding", category: "Product Analytics" },
  { name: "Product specs", category: "Product Management" },
  { name: "Roadmapping", category: "Product Management" },
  { name: "Prioritisation", category: "Product Management" },
  { name: "User research", category: "Product Management" },
  { name: "Growth experiments", category: "Product Management" },
  { name: "GTM & launches", category: "Product Management" },
  { name: "Decision memos", category: "Product Management" },
  { name: "Documentation", category: "Product Management" },
  { name: "ETL pipelines", category: "Data Engineering" },
  { name: "Web scraping", category: "Data Engineering" },
  { name: "Data modelling", category: "Data Engineering" },
  { name: "Schema design", category: "Data Engineering" },
  { name: "Data validation", category: "Data Engineering" },
  { name: "Reconciliation", category: "Data Engineering" },
  { name: "API integration", category: "Data Engineering" },
  { name: "Caching", category: "Data Engineering" },
  { name: "JavaScript", category: "Languages" },
  { name: "TypeScript", category: "Languages" },
  { name: "Python", category: "Languages" },
  { name: "SQL", category: "Languages" },
  { name: "React.js", category: "Frontend / Web" },
  { name: "Next.js", category: "Frontend / Web" },
  { name: "Tailwind CSS", category: "Frontend / Web" },
  { name: "Node.js", category: "Backend / Data" },
  { name: "Flask", category: "Backend / Data" },
  { name: "FastAPI", category: "Backend / Data" },
  { name: "AWS (EC2, S3)", category: "Cloud & Serverless" },
  { name: "GCP (Cloud Functions, Vertex AI)", category: "Cloud & Serverless" },
  { name: "Serverless Pipelines", category: "Cloud & Serverless" },
  { name: "Docker", category: "DevOps (basics)" },
  { name: "CI/CD (GitHub Actions)", category: "DevOps (basics)" },
  { name: "Vercel deploys", category: "DevOps (basics)" },
  { name: "Env & secrets config", category: "DevOps (basics)" },
  { name: "Logging & monitoring", category: "DevOps (basics)" },
  { name: "Webhooks & networking", category: "DevOps (basics)" },
  { name: "PostgreSQL", category: "Datastores" },
  { name: "MongoDB", category: "Datastores" },
  { name: "Redis", category: "Datastores" },
  { name: "MySQL", category: "Datastores" },
  { name: "OpenAI", category: "ML/AI" },
  { name: "Hugging Face", category: "ML/AI" },
  { name: "Production Inference", category: "ML/AI" },
  { name: "CrewAI", category: "ML/AI" }
];

export const skillCategoryOrder = [
  "Product Analytics",
  "Product Management",
  "Data Engineering",
  "Languages",
  "Frontend / Web",
  "Backend / Data",
  "Cloud & Serverless",
  "DevOps (basics)",
  "Datastores",
  "ML/AI"
];

/* Projects & ventures. The Emergent work and the two self-initiated data
   projects are the short version of the write-ups in my print portfolio. */
export const projects = [
  {
    id: 1,
    title: "Hitrate",
    description:
      "Paste your TikTok, Instagram, YouTube or X profile and it reads every recent post for hook, angle, format and emotion, then tells you which patterns make your hits hit.",
    tech: ["Product", "Creator analytics", "Tag taxonomy", "Next.js"],
    link: "#",
    featured: true,
    highlight: "Work in progress · 70-tag taxonomy, piloted on 51 of my own posts · an early tool for what I'm building next"
  },
  {
    id: 2,
    title: "HealthNivaran",
    description:
      "AI agents that interview patients before an appointment and hand the doctor a clean one-page clinical summary. Automated the first layer of outpatient care so doctors could see 1.5x more patients in the same clinic hours.",
    tech: ["AI Agents", "Healthcare", "Automation", "Patient Care"],
    link: "https://healthnivaran.in",
    featured: true,
    highlight: "Ran pilots with doctors at Narayana Health, Apollo & Fortis"
  },
  {
    id: 3,
    title: "Nivaran — Slack data bot",
    description:
      "@mention it in plain English and it answers from our internal analytics. The model routes to one of seven vetted queries instead of writing SQL, so the team's conventions never get silently broken.",
    tech: ["LLM tool design", "FastAPI", "Slack", "Gemini"],
    link: "#",
    featured: true,
    highlight: "Self-initiated inside my team at Emergent"
  },
  {
    id: 4,
    title: "Mr. Wonderful's Deals",
    description:
      "Every site gives a different count of Kevin O'Leary's Shark Tank deals, from about 40 to 133. I built a source-verified dataset across 17 seasons and wrote down the definition of “a deal” before writing any code.",
    tech: ["Data engineering", "Web scraping", "Methodology"],
    link: "#",
    featured: true,
    highlight: "145 on-air deals · the spread was a definition problem, not a data problem"
  },
  {
    id: 5,
    title: "Creator Intelligence Platform",
    description:
      "A two-app system that detects a sponsored creator post within an hour of it going live, scrapes its views and comments, and joins them to the signups and revenue from that creator's referral link.",
    tech: ["Data pipelines", "LLM detection", "Attribution", "Apify"],
    link: "#",
    featured: false,
    highlight: "Built at Emergent · my role: analytics owner, system designer, QC"
  },
  {
    id: 6,
    title: "The Creator Blackout",
    description:
      "What happens to signups and conversions when you switch a creator channel off. The honest answer needed cohort thinking, not before-and-after averages, and it changed how we read referral data.",
    tech: ["Causal reasoning", "Cohort analysis", "SQL", "Decision memo"],
    link: "#",
    featured: false,
    highlight: "Impact analysis at Emergent · figures generalised, company-confidential"
  },
  {
    id: 7,
    title: "Live Translator & Flash",
    description:
      "Two Chrome extensions I built because reviewing hundreds of creator videos was eating my week: one-click English transcripts for any TikTok or Instagram video, and speed control up to 4× with a 10-second seek.",
    tech: ["Chrome extensions", "Gemini", "Scraping"],
    link: "#",
    featured: false,
    highlight: "Version 0.7, used daily"
  },
  {
    id: 8,
    title: "Medicine Delivery Chatbot",
    description:
      "A chatbot for Narayana Health's subscribed users to streamline medicine delivery and automate call-based appointment booking.",
    tech: ["Chatbot", "Automation", "Healthcare", "NLP"],
    link: "#",
    featured: false,
    highlight: "Built at Narayana Health"
  }
];

export const experience = [
  {
    id: 1,
    role: "Product Growth",
    company: "Emergent",
    url: "https://emergent.sh",
    type: "Full-time",
    duration: "Jul 2026 - Nov 2026",
    location: "Bengaluru, Karnataka, India",
    mode: "On-site",
    description:
      "Led analytics for creator marketing across $50M+ in yearly spend.",
    bullets: [
      "Helped run **4 Builderfests** (India, Türkiye, Indonesia, France) and **2 global campaigns** (Builder Fest with Kevin O'Leary, the Fabrizio Romano x Emergent Builder's Contest), plus the creator amplification behind them.",
      "Managed the creator program across European and English-speaking markets.",
      "Built creator-level attribution tying every creator deal to real signups and revenue, and cost-per-signup by country that directly shaped where the budget went.",
      "Automated the pipeline from vetting creators to paying them and reconciling every payment.",
      "Built a tool that reads video transcripts and scores the content, so we knew which themes win in which country.",
      "Worked with Kevin O'Leary and built tools for him."
    ],
    current: false
  },
  {
    id: 2,
    role: "Product Intern",
    company: "Emergent",
    url: "https://emergent.sh",
    type: "Internship",
    duration: "Apr 2026 - Jul 2026",
    location: "Bengaluru, Karnataka, India",
    mode: "On-site",
    description:
      "Joined on 6 April 2026 in a product role, with the best autonomy a college student can ask for at a unicorn. Owned the analytics side of the Creator Intelligence Platform: the data pipelines, the LLM post-detection, the attribution join and the documentation. Converted to full-time Product Growth in July.",
    current: false
  },
  {
    // kept as written
    id: 3,
    role: "Founder & CEO",
    company: "HealthNivaran",
    url: "https://healthnivaran.in",
    duration: "Oct 2025 - Apr 2026",
    location: "Bengaluru, Karnataka, India",
    description:
      "Doctors spend up to 40% of their time on manual data entry, history-taking and documentation. Nivaran automated the first layer of outpatient care, saving doctors time and enabling them to see more patients.",
    current: false
  },
  {
    id: 4,
    role: "Entrepreneur in Residence",
    company: "Entrepreneur First",
    url: "https://www.joinef.com",
    type: "Full-time",
    duration: "Oct 2025 - Mar 2026",
    location: "Bengaluru, Karnataka, India",
    mode: "On-site",
    description:
      "Founded HealthNivaran here: an intelligence layer on top of patient data, no installation, simple plug and play. Started with an AI doctor on WhatsApp and iterated through six pivots before the point got clear.",
    bullets: [
      "**Talk to your hospital data.** MIS teams take weeks to make sense of data, so we let admins ask in plain English and get answers with actionable next steps: your hospital had 30% fewer patients in department X, here are five things to fix.",
      "**AI front desk.** Half the calls to a hospital are the same ten questions. We automated that layer so staff could focus on real patients.",
      "**AI-first telemedicine.** Doctors burn hours on patients who need a paracetamol, not a consultation. AI screens first; doctors see only who needs them.",
      "**Filtering high-value patients.** A surgeon makes ₹5L per surgery in under an hour, and ₹10K seeing ten patients in the same hour of OPD, most of whom want a second opinion. We filtered so he only saw surgical candidates, with an AI-powered first examination handling the rest.",
      "**A safe space for sexual health.** The barrier isn't access to doctors, it's shame. AI handles the uncomfortable first conversation, so by the time the patient sees the doctor the hard part is done.",
      "**AI clinical co-pilot.** AI recommends treatment from history, symptoms and lifestyle; the doctor approves or edits, and every correction becomes training data.",
      "**AI agents for doctors.** After six pivots: doctors don't need another dashboard, they need the paperwork, follow-ups and admin handled. We stopped trying to replace judgment and started replacing the work around it."
    ],
    current: false
  },
  {
    id: 5,
    role: "Advanced Product Analytics",
    company: "Narayana Health",
    type: "Internship",
    duration: "Apr 2025 - Sep 2025",
    location: "Bengaluru, Karnataka, India",
    mode: "On-site",
    description:
      "Received the internship offer directly from Vice Chairman Viren Shetty via a cold message.",
    bullets: [
      "Built a chatbot for medicine delivery.",
      "Shadowed doctors across cardiology, neuroscience and oncology to find the real pain points.",
      "Gave co-pilots to the call centre workers.",
      "Built an ECG reader that directs a patient to the right cardiac speciality, with Dr. Deepak."
    ],
    current: false
  },
  {
    id: 6,
    role: "Founder",
    company: "Magnumkare",
    type: "Full-time",
    duration: "Apr 2024 - Jan 2025",
    location: "India",
    description:
      "A healthcare-focused digital agency I started from my hometown, specialising in website development, social media management and content creation for hospitals and doctors. Scaled across 4 cities within 8 months.",
    bullets: [
      "Received cheques from 7 hospitals, 3 clinics and 1 diagnostic lab.",
      "The goal was to get connected with doctors as someone from a completely non-medical background.",
      "Shut down once that purpose was fulfilled."
    ],
    current: false
  },
  {
    id: 7,
    role: "Founding Member",
    company: "Growth4x",
    type: "Full-time",
    duration: "Sep 2023 - Apr 2024",
    location: "Noida, Uttar Pradesh, India",
    description:
      "Built a team that worked with brands like Pristyn Care, Cudel, Airtel and more.",
    current: false
  },
  {
    id: 8,
    role: "Freelancer",
    company: "Fiverr",
    type: "Self-employed",
    duration: "May 2021 - Aug 2023",
    location: "Remote",
    mode: "Remote",
    description: "Worked with over 30 brands across the globe, and made my first $1000 here.",
    bullets: [
      "Got 2 legal notices as well: one from a travel planning company, one from a fintech.",
      "Trained my muscle for multitasking and getting work done no matter what. High ownership."
    ],
    current: false
  }
];

export const tools = [
  { name: "Claude", category: "AI & Building" },
  { name: "Claude Code", category: "AI & Building" },
  { name: "Gemini 2.5 Pro", category: "AI & Building" },
  { name: "Cursor", category: "AI & Building" },
  { name: "ChatGPT", category: "AI & Building" },
  { name: "v0", category: "AI & Building" },
  { name: "Apify", category: "AI & Building" },
  { name: "Redash", category: "Analytics & Experimentation" },
  { name: "PostHog", category: "Analytics & Experimentation" },
  { name: "Mixpanel", category: "Analytics & Experimentation" },
  { name: "GA4", category: "Analytics & Experimentation" },
  { name: "Metabase", category: "Analytics & Experimentation" },
  { name: "Attio", category: "Growth & GTM" },
  { name: "HubSpot", category: "Growth & GTM" },
  { name: "Apollo", category: "Growth & GTM" },
  { name: "Resend", category: "Growth & GTM" },
  { name: "Customer.io", category: "Growth & GTM" },
  { name: "Figma", category: "Design & Ship" },
  { name: "Notion", category: "Design & Ship" },
  { name: "Linear", category: "Design & Ship" },
  { name: "Vercel", category: "Design & Ship" },
  { name: "Supabase", category: "Design & Ship" }
];

export const toolCategories = [
  {
    name: "AI & Building",
    blurb: "Prototyping, agents, and the scrapers that read creator video."
  },
  {
    name: "Analytics & Experimentation",
    blurb: "Funnels, dashboards, and reading whether a change moved anything."
  },
  {
    name: "Growth & GTM",
    blurb: "CRM, outbound, and lifecycle email."
  },
  {
    name: "Design & Ship",
    blurb: "Design, specs, tickets, and deploys."
  }
];

export const journey = [
  "Started as a freelancer, then founded **MagnumKare**, working with hospitals on websites and social media, despite having zero medical background, not even a nurse in my entire bloodline.",
  "That exposure pulled me deeper into healthcare, where I began building real systems, not just services.",
  "I joined [Entrepreneur First](https://www.joinef.com), explored multiple healthcare ideas, from ECG readers to pre-triaging tools, and built [HealthNivaran](https://healthnivaran.in): AI agents that interview patients beforehand and hand the doctor a clean one-page clinical summary.",
  "Then I joined [Emergent](https://emergent.sh), an AI platform that turns a prompt into a deployed app, now valued at $1.5 billion. In 8 months I went from product intern to leading analytics for creator marketing, then resigned at my peak to build again. {{Different industry, same job: find where people drop off, and go fix it.}}"
];

export const education = [
  {
    degree: "Bachelor of Science, Computer Science",
    institution: "Birla Institute of Technology and Science, Pilani",
    year: "Aug 2024 - Jul 2028",
    description:
      "Fully online degree program offered by BITS. Complete flexibility to do it from anywhere in the world.",
    grade: "8"
  },
  {
    degree: "Computer Science",
    institution: "Scaler School of Technology",
    year: "Aug 2024 - Jul 2025",
    description:
      "Integrated program with BITS Pilani. Great mentors & peers led to a startup & AI internship at Narayana Health in my first year. Grateful to Scaler for the exposure and guidance."
  }
];

export const navLinks = [
  { name: "Emergent", href: "#emergent" },
  { name: "Campaigns", href: "#campaigns" },
  { name: "Letter", href: "#letter" },
  { name: "Next", href: "#next" },
  { name: "Track record", href: "#experience" },
  { name: "Projects", href: "#projects" },
  { name: "Contact", href: "#contact" }
];

/* ---------- At Emergent (Apr - Nov 2026) ---------- */

// Spend is "$50M+ yearly" (confirmed by Shashank).
export const emergentStats = [
  { value: "$50M+", label: "Yearly creator spend", detail: "Led the analytics behind it" },
  { value: "4", label: "Builderfests", detail: "India, Türkiye, Indonesia, France" },
  { value: "2", label: "Global campaigns", detail: "Kevin O'Leary, Fabrizio Romano" },
  { value: "8 mo", label: "Apr - Nov 2026", detail: "Product intern to Product Growth" }
];

export const emergentContext =
  "Emergent is an AI platform that turns a prompt into a deployed app, valued at $1.5 billion. I led analytics for creator marketing and managed the creator program across European and English-speaking markets.";

export const emergentSystems = {
  signature: [
    {
      kicker: "Signature system 01",
      title: "Every creator deal, tied to revenue",
      body:
        "Creator-level attribution that linked every creator deal to real signups and revenue. On top of it, {{cost-per-signup by country, which directly shaped where we put our budget.}}",
      points: [
        "Designed and owned the analytics for a two-app system that detects a sponsored post within an hour of it going live and joins its views and comments to the signups and revenue from that creator's referral link.",
        "A Slack data bot so the team could ask our internal analytics questions in plain English."
      ],
      tint: "mint"
    },
    {
      kicker: "Signature system 02",
      title: "Which themes win in which country",
      body:
        "A tool that reads video transcripts and scores the content, so we knew {{which themes win in which country}} instead of guessing.",
      points: [
        "Turned creative review from taste into evidence, market by market.",
        "The system Aseem Sharma (Head of Revenue and Growth) singled out in his letter: it made our creative strategy noticeably sharper."
      ],
      tint: "blue"
    }
  ],
  pipeline: {
    kicker: "The backbone",
    title: "Vetting to payment, automated",
    body:
      "The backbone of our influencer marketing: one automated pipeline from vetting creators to paying them and reconciling every payment."
  }
};

export const emergentRule = {
  before: "Does this creator feel right?",
  after: "What does the data say works in this market?",
  lesson: "Ownership is rarely handed to you. You have to earn it, task after task, by constantly proving yourself."
};

/* Campaign gallery. Launch posts from @emergentlabs and the creator reel.
   Prize pools are copied from each post's caption. */
export const campaignMedia = [
  {
    file: "builderfest-india-raj-shamani",
    kind: "reel",
    group: "builderfest",
    label: "Builderfest India with Raj Shamani",
    country: "India",
    prize: "₹1 Crore",
    note: "India launch: 14-day build challenge",
    plays: "2M+ plays",
    url: "https://www.instagram.com/rajshamani/reel/DaDOcyqpFjd/",
    credit: "@rajshamani",
    width: 1080,
    height: 1920,
    tone: "yellow"
  },
  {
    file: "builderfest-turkiye",
    kind: "poster",
    group: "builderfest",
    label: "Builders' Fest Türkiye",
    country: "Türkiye",
    prize: "₺2M · 100 winners",
    url: "https://www.instagram.com/emergentlabs/p/DbqieseqEIv/",
    credit: "@emergentlabs",
    width: 1440,
    height: 1800,
    tone: "pink"
  },
  {
    file: "builderfest-indonesia",
    kind: "poster",
    group: "builderfest",
    label: "Builders' Fest Indonesia",
    country: "Indonesia",
    prize: "Rp 800M · 100 winners",
    url: "https://www.instagram.com/emergentlabs/p/Db8XWeKtj8t/",
    credit: "@emergentlabs",
    width: 1440,
    height: 1800,
    tone: "mint"
  },
  {
    file: "builderfest-france",
    kind: "poster",
    group: "builderfest",
    label: "Builders' Fest France",
    country: "France",
    prize: "€40,000 · 100 winners",
    url: "https://www.instagram.com/emergentlabs/p/Db8pNN_K_pa/",
    credit: "@emergentlabs",
    width: 1440,
    height: 1800,
    tone: "blue"
  },
  {
    file: "builderfest-global-kevin-oleary",
    kind: "poster",
    group: "global",
    label: "Global: Builder Fest with Kevin O'Leary",
    prize: "$100K · 100 winners",
    url: "https://www.instagram.com/emergentlabs/p/DcToar2KqFL/",
    credit: "@emergentlabs",
    width: 1440,
    height: 1800,
    tone: "yellow"
  },
  {
    file: "global-fabrizio-romano",
    kind: "poster",
    group: "global",
    label: "Global: Fabrizio Romano x Emergent Builder's Contest",
    prize: "$100K",
    url: "https://www.instagram.com/emergentlabs/p/DaP8dPwKZOO/",
    credit: "@emergentlabs",
    width: 1440,
    height: 1800,
    tone: "blue"
  }
];

/* Letter of recommendation. Verbatim: do not edit the wording. */
export const recommendation = {
  author: "Aseem Sharma",
  title: "Head of Revenue and Growth",
  company: "Emergent",
  photo: "/media/aseem-sharma.jpg",
  linkedin: "https://www.linkedin.com/in/sharmaaseem01/",
  pullQuote: "One of the highest-ownership people on my growth team at Emergent.",
  highlight: "He combines a builder's instinct with an operator's discipline.",
  paragraphs: [
    "Shashank was one of the highest-ownership people on my growth team at Emergent. He helped us run four major Builderfest events across India, Turkey, Indonesia and France, drove two global campaigns, and managed our creator program across European and English-speaking markets. He also automated the full pipeline behind our influencer marketing spend, from creator vetting all the way to payments and reconciliation.",
    "What sets him apart is that he measures everything. He built creator-level attribution that linked every creator deal to real signups and revenue, and his cost-per-signup analysis by country directly shaped where we put our budget.",
    "One system that truly impressed me was the one he built to identify which content themes work in which market. It made our creative strategy noticeably sharper.",
    "He combines a builder's instinct with an operator's discipline. Any team would be lucky to have him."
  ]
};

/* What I'm building next, from the resignation post. No traction claims. */
export const buildingNext = {
  question:
    "Run your entire marketing just by talking in English.",
  answer:
    "That's the platform I'm building. Right now I'm {{building my own tools and running GTM experiments}} to get there.",
  now: [
    "First tool: **Hitrate** (work in progress). It reads every recent post on a profile for hook, angle, format and emotion and tells you which patterns make your hits hit.",
    "How it fits: Hitrate is the platform's **\"what works\" engine**, the same idea as the transcript and theme scoring I ran on creator videos at Emergent, pointed at any account's own posts, a creator's or a business's.",
    "Why me: at Emergent I ran creator marketing on pure data signals about what works in each market, not gut calls. Now I'm building my own tools and running GTM experiments to bring that to people who don't have a marketing team."
  ]
};
